import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import Feature from "./components/Feature";
import TimelineSection from "./components/TimelineSection";
import ShotsSection from "./components/ShotsSection";
import ChatSection from "./components/ChatSection";
import MediaSection from "./components/MediaSection";
import EvidenceKit from "./components/EvidenceKit";
import ArchiveBand from "./components/ArchiveBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Feature />
        <TimelineSection />
        <ShotsSection />
        <ChatSection />
        <MediaSection />
        <EvidenceKit />
        <ArchiveBand />
      </main>
      <Footer />
    </div>
  );
}